<template>
    <ValidationObserver ref="validation">
        <label for="insurance">{{ $t('Insurance data')}}</label>
        <fieldset id="insurance">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input id="insured" v-model="insured" :aria-label="$t('Insure the contents')" type="checkbox" @change="updateInsured">
                            </div>
                        </div>
                        <div class="form-control">
                            <label class="form-check-label" for="insured">{{ $t('Insure the contents') }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div v-show="insured" class="form-group col-md-6">
                    <label class="sr-only" for="amount">{{ $t('Amount insured') }}</label>
                    <ValidationProvider v-slot="{ errors, classes, ariaMsg, ariaInput }" rules="required|integer|min_value:150|max_value:3000" vid="amount">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa fa-euro-sign"></i></div>
                            </div>
                            <input id="amount" v-model="amount" v-bind="ariaInput" :class="classes" :placeholder="$t('Amount insured')" class="form-control" type="number" min="150" max="3000" @change="updateAmount"/>
                            <span v-bind="ariaMsg" class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <span v-if="showCost && this.cost">
                {{ $t('Insurance cost:') }}
                {{ formatCost() }}
            </span>
        </fieldset>
    </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: "InsuranceForm",
    components: { ValidationProvider, ValidationObserver },
    props: {
        showCost: {type: Boolean},
    },
    computed: {
        errors() {
            return this.$refs.validation ? this.$refs.validation.$data.errors : undefined;
        },
        cost() {
            return this.$store.getters['order/insurance/cost'];
        }
    },
    data() {
        return {
            insured: this.$store.state.order.insurance.insured,
            amount: this.$store.state.order.insurance.amount,
        };
    },
    methods: {
        updateInsured() {
            this.$store.commit('order/insurance/setInsured', this.insured);
            this.amount = undefined;
            this.updateAmount();
        },
        updateAmount() {
            this.$store.commit('order/insurance/setAmount', this.errors.amount.length ? undefined : this.amount);
        },
        formatCost() {
            return Intl.NumberFormat(
                document.body.dataset.locale,
                {style: 'currency', currency: process.env.MIX_SALES_CURRENCY}
            ).format(this.cost + this.cost * process.env.MIX_SALES_VAT);
        },
    }
}
</script>
